import { CustomError } from './customError';

export class UnknownApiResponseError extends CustomError {

  constructor(message?: string) {
    const m = message ?? 'UnknownApiResponseError';
    super(m);

    Object.setPrototypeOf(this, new.target.prototype);
    this.name = 'UnknownApiResponseError';
  }
}
